const AuthPageLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="h-screen w-full flex justify-center items-center bg-white dark:bg-background/paper-elevation-1">
    {children}
  </div>
);

export default AuthPageLayout;
